import React from "react";
import { Col, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import "./Jobs.scss";
const SkeletonJobDetails = () => {

  return (
    <>
    <div className="dark-theme padding-top">
    <div className="container">
        <div className="row">
            <div className="col">

            </div>
        </div>
        <div className="row">
            <div className="col w-100">

                <h1 className="heading"><Skeleton width={650} /></h1>

                <div className="row flex-column flex-md-row">
                    <div className="col col-md-6">
                        <span className="job-ref mb-2 mb-md-4"><Skeleton width={30} /></span>
                        <span className="post-date fw-bold mb-2 mb-md-4"><Skeleton width={140} /></span>
                    </div>
                    <div className="col col-md-6">
                        <div className="d-flex justify-content-start justify-content-md-end">
                           {/* <Skeleton width={150} /> */}
                        </div>
                    </div>
                </div>
                <div className="row flex-column flex-md-row">
                    <div className="col">
                        <ul className="job-data-highlights p-0">
                            <li>
                                <Skeleton width={150} />
                            </li>
                            <li>
                               <Skeleton width={150} />
                            </li>
                            
                        </ul>
                    </div>
                    <div className="col">

                </div>
            </div>
        </div>
    </div>
</div>
</div>
<div className="container padding-top" id="jobDetails" data-relatedsearch="">
    <div className="row">
        <div className="col">
            <div className="job-data">
                <div className="row">
                    <div className="content">
                        <div className="rte">
                          <Skeleton count={3} />
                          <Skeleton count={2} width={650} />
                          <Skeleton count={1} width={150} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
      
    </div>
   
</div>

     
    </>
  );
};

export default SkeletonJobDetails;
